class InfiniteScroll {
  constructor() {
    this.currentPage = 1;
    this.loading = false;
    this.allLoaded = false; // Track if all products are loaded
    this.observer = null;
    this.productsContainer = document.querySelector('#product-grid');
    // Create a bottom loading spinner
    this.loadingIndicator = this.createBottomSpinner();
    
    if (this.productsContainer) {
      this.init();
    }
  }

  init() {
    // Create intersection observer
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.loading) {
          this.loadMoreProducts();
        }
      });
    }, {
      rootMargin: '100px'
    });

    // Observe the last product card
    this.observeLastProduct();
  }

  observeLastProduct() {
    const lastProduct = this.productsContainer.querySelector('.grid__item:last-child');
    if (lastProduct) {
      this.observer.observe(lastProduct);
    }
  }

  async loadMoreProducts() {
    if (this.loading || this.allLoaded) return;
    
    this.loading = true;
    this.showLoading();

    try {
      const nextPage = this.currentPage + 1;
      const url = new URL(window.location.href);
      url.searchParams.set('page', nextPage);
  // Do not request a section-only partial; fetch the full page so server renders full product markup (including product-form/add-to-cart)

      const response = await fetch(url);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      const newProducts = doc.querySelector('#product-grid');
      if (newProducts) {
        const products = newProducts.querySelectorAll('.grid__item');
        if (products.length > 0) {
          // Prevent duplicates by checking product handle or data-id
          products.forEach(product => {
            // Use data-product-id for duplicate detection
            let pid = product.getAttribute('data-product-id');
            let exists = false;
            if (pid) {
              exists = !!this.productsContainer.querySelector('[data-product-id="' + pid + '"]');
            }
            if (!exists) {
              // Import node into current document to avoid adopted/adoptedStyle issues
              const imported = document.importNode(product, true);

              // If there are any script tags inside the imported node, re-execute them
              const scripts = imported.querySelectorAll('script');
              scripts.forEach(oldScript => {
                const newScript = document.createElement('script');
                // Copy attributes
                for (let i = 0; i < oldScript.attributes.length; i++) {
                  const attr = oldScript.attributes[i];
                  newScript.setAttribute(attr.name, attr.value);
                }
                // Copy inline script content
                newScript.text = oldScript.textContent;
                oldScript.parentNode.replaceChild(newScript, oldScript);
              });

              // Append imported node
              this.productsContainer.appendChild(imported);

              // Ensure any custom elements inside the appended node are upgraded
              if (window.customElements && typeof window.customElements.upgrade === 'function') {
                // Walk through elements and upgrade ones with a hyphen (custom element) or known names
                const all = imported.querySelectorAll('*');
                all.forEach(el => {
                  if (el.tagName && el.tagName.indexOf('-') > -1) {
                    try { window.customElements.upgrade(el); } catch (e) { /* ignore */ }
                  }
                });
                // Also attempt to upgrade the root if it's a custom element
                if (imported.tagName && imported.tagName.indexOf('-') > -1) {
                  try { window.customElements.upgrade(imported); } catch (e) { /* ignore */ }
                }
              }
              // Dispatch event to signal new content was added
              try {
                const ev = new CustomEvent('infinite-content:added', { detail: { productId: pid || null } });
                document.dispatchEvent(ev);
              } catch (e) {
                // ignore event errors on older browsers
              }
            }
          });
          this.currentPage = nextPage;
          this.observeLastProduct();
        } else {
          // No more products to load
          this.allLoaded = true;
          this.hideLoading();
          if (this.observer) {
            this.observer.disconnect();
          }
        }
      } else {
        // No more products to load
        this.allLoaded = true;
        this.hideLoading();
        if (this.observer) {
          this.observer.disconnect();
        }
      }
    } catch (error) {
      console.error('Error loading more products:', error);
    } finally {
      this.loading = false;
      if (!this.allLoaded) {
        this.hideLoading();
      }
    }
  }

  showLoading() {
    if (this.loadingIndicator) {
      this.loadingIndicator.style.display = 'flex';
    }
  }

  hideLoading() {
    if (this.loadingIndicator) {
      this.loadingIndicator.style.display = 'none';
    }
  }

  createBottomSpinner() {
    let spinner = document.createElement('div');
    spinner.className = 'infinite-scroll-spinner';
    spinner.style.display = 'none';
    spinner.style.justifyContent = 'center';
    spinner.style.alignItems = 'center';
    spinner.style.padding = '16px';
    spinner.innerHTML = `<svg aria-hidden="true" focusable="false" width="32" height="32" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30" stroke="#999"></circle></svg>`;
    if (this.productsContainer) {
      this.productsContainer.parentElement.appendChild(spinner);
    }
    return spinner;
  }
}

// Initialize infinite scroll when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new InfiniteScroll();
}); 